export default __webpack_public_path__ + "static/media/icon.info.2.56c1cd7e.svg";